import Plugin from '../core/Plugin';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import * as SelectionUtils from '../SelectionUtils';
import { escapeHtml } from '../utils/htmlUtils';

/**
 * MathPlugin - Handles LaTeX and MathML insertion
 */
class MathPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'Math';
  }

  executeCommand(command) {
    switch (command) {
      case 'insertLatex':
        this.insertLatex();
        break;
      case 'insertMathML':
        this.insertMathML();
        break;
    }
  }

  insertLatex() {
    const latex = prompt('Enter LaTeX expression (e.g., E = mc^2):');
    if (latex) {
      try {
        const html = katex.renderToString(latex, {
          throwOnError: false,
          displayMode: false,
        });
        // Escape the LaTeX for safe use in HTML attribute
        const escapedLatex = escapeHtml(latex);
        // Always apply 13.5pt font size to math
        SelectionUtils.insertHTML(
          `<span class="quillkit-math" contenteditable="false" data-latex="${escapedLatex}" data-display-mode="false" style="font-size: 13.5pt;">${html}</span>`
        );
      } catch (e) {
        alert('Error rendering LaTeX: ' + e.message);
      }
    }
  }

  insertMathML() {
    const mathml = prompt('Enter MathML code:');
    if (mathml) {
      SelectionUtils.insertHTML(mathml);

      // Trigger MathML rendering to ensure colors are applied
      if (this.editor.processMathContent) {
        this.editor.processMathContent();
      }

      // Apply 13.5pt font size to math
      this.applyDefaultFontSize();
    }
  }

  /**
   * Apply 13.5pt font size to all math elements in the editor
   */
  applyDefaultFontSize() {
    if (!this.editor.richEditor) {
      return;
    }

    // Selector for all math element types
    const MATH_SELECTOR = '.quillkit-math, .quillkit-mathml, math';
    const mathElements = this.editor.richEditor.querySelectorAll(MATH_SELECTOR);

    mathElements.forEach((mathEl) => {
      // Only apply if element has a style property and no font-size is already set
      if (mathEl && mathEl.style && !mathEl.style.fontSize) {
        mathEl.style.fontSize = '13.5pt';
      }
    });
  }

  /**
   * Called after editor is fully initialized
   */
  afterEditorInit() {
    // Apply 13.5pt font size to any existing math elements
    this.applyDefaultFontSize();
  }

  getMetadata() {
    return {
      name: 'Math Support',
      version: '1.0.0',
      description: 'Provides LaTeX and MathML rendering support using KaTeX',
      author: 'AtlaraFirm',
    };
  }
}

export default MathPlugin;
